import React from 'react';
import PastBlastList from '../blast_sms/PastBlastList';

function Newsletter() {
    return (
        <PastBlastList
            title="Past Email Newsletter"
            description="Track email newsletters from creation through send completion."
            icon="bi-envelope-paper"
            type="EMAIL"
            category="NEWSLETTER"
            entityLabel="Newsletter"
            createPath="/newsletter/create-email"
            createLabel="Create Email Newsletter"
            resultsBasePath="/newsletter/email"
            emptyTitle="No email newsletters yet"
            emptyDescription="Create an email newsletter to message selected patients. Past launches will show here with status."
            infoText="Only patients with an email address who have not opted out of email newsletters are eligible. While Pending, you can Stop a newsletter before it sends. Use Results after a newsletter completes or errors."
        />
    );
}

export default Newsletter;
